module.exports = __webpack_public_path__ + "img/u166.236702aa.svg";